module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei1.svg";